import script from "./MaxLaborPerMonthModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaxLaborPerMonthModal.vue?vue&type=script&setup=true&lang=ts"

import "./MaxLaborPerMonthModal.vue?vue&type=style&index=0&id=1a359b9e&scoped=true&lang=css"
import "./MaxLaborPerMonthModal.vue?vue&type=style&index=1&id=1a359b9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a359b9e"]])

export default __exports__